var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 15,
    height: 15,
    transform: "translate(1316 340)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_17",
    "data-name": "Mask Group 17",
    transform: "translate(-1316 -340)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(1316 340)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M15,7.5S12.188,2.344,7.5,2.344,0,7.5,0,7.5s2.813,5.156,7.5,5.156S15,7.5,15,7.5ZM1.1,7.5A12.312,12.312,0,0,1,2.656,5.585,6.985,6.985,0,0,1,7.5,3.281a6.991,6.991,0,0,1,4.845,2.3A12.312,12.312,0,0,1,13.9,7.5c-.054.082-.114.172-.183.27a12.363,12.363,0,0,1-1.373,1.645,6.993,6.993,0,0,1-4.845,2.3,6.991,6.991,0,0,1-4.845-2.3A12.313,12.313,0,0,1,1.1,7.5Z",
    fill: "#ffc02c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M7.5,5.156A2.344,2.344,0,1,0,9.844,7.5,2.344,2.344,0,0,0,7.5,5.156ZM4.219,7.5A3.281,3.281,0,1,1,7.5,10.781,3.281,3.281,0,0,1,4.219,7.5Z",
    fill: "#ffc02c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowEye);
export default __webpack_public_path__ + "static/media/yellow-eye.c154b6b7689c75e6b74170ea12f448bf.svg";
export { ForwardRef as ReactComponent };